import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import dsteem from "../unit/DsteemUtil";
import { getAccount, extractLoginData } from "../unit/UserUtil";
import PostCard from "../components/PostComponents/PostCard.vue";
import { $t } from "../plugins/i18n";
export default {
  components: {
    PostCard: PostCard
  },
  data: function data() {
    return {
      editableTabsValue: "1",
      editableTabs: [{
        title: $t("label.blog"),
        name: "1",
        tableData: []
      }, {
        title: $t("label.post"),
        name: "2"
      }],
      blogs: null,
      posts: null,
      headImg: "",
      userName: "",
      location: "",
      about: "",
      postCount: 0,
      following: 0,
      followers: 0,
      votingPower: 0,
      isSelf: true,
      isFollowed: false,
      isMuted: false
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var account;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getAccount(_this.userName);

              case 2:
                account = _context.sent;
                _this.headImg = account.profile_image;
                _this.likeid = account.likeid;
                _this.location = account.location;
                _this.about = account.about;
                _this.postCount = account.post_count;
                _context.next = 10;
                return dsteem.getFollowing(_this.userName);

              case 10:
                _this.following = _context.sent;
                _context.next = 13;
                return dsteem.getFollowers(_this.userName);

              case 13:
                _this.followers = _context.sent;
                _this.votingPower = account.voting_power;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefreshBlogs: function onRefreshBlogs(done) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dsteem.getAccountBlogsByBridge(_this2.loginData ? _this2.loginData[0] : null, "blog", _this2.userName, 20);

              case 2:
                _this2.blogs = _context2.sent;
                done();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onLoadBlogs: function onLoadBlogs(done) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var permlink, author, nextblogs;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.blogs[_this3.blogs.length - 1]) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                permlink = _this3.blogs[_this3.blogs.length - 1].permlink;
                author = _this3.blogs[_this3.blogs.length - 1].author;
                _context3.next = 6;
                return dsteem.getAccountBlogsByBridge(_this3.loginData ? _this3.loginData[0] : null, "blog", _this3.userName, 20, permlink, author);

              case 6:
                nextblogs = _context3.sent;
                nextblogs.shift();

                _this3.blogs.push.apply(_this3.blogs, nextblogs);

                done();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onRefreshPosts: function onRefreshPosts(done) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dsteem.getAccountBlogsByBridge(_this4.loginData ? _this4.loginData[0] : null, "posts", _this4.userName, 20);

              case 2:
                _this4.posts = _context4.sent;
                done();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onLoadPosts: function onLoadPosts(done) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var permlink, author, nextposts;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.posts[_this5.posts.length - 1]) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                permlink = _this5.posts[_this5.posts.length - 1].permlink;
                author = _this5.posts[_this5.posts.length - 1].author;
                _context5.next = 6;
                return dsteem.getAccountBlogsByBridge(_this5.loginData ? _this5.loginData[0] : null, "posts", _this5.userName, 20, permlink, author);

              case 6:
                nextposts = _context5.sent;
                nextposts.shift();

                _this5.posts.push.apply(_this5.posts, nextposts);

                done();

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    follow: function follow(isFollow) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.isFollowed = isFollow;
                _this6.loginData = extractLoginData();

                if (_this6.loginData) {
                  _context6.next = 7;
                  break;
                }

                _this6.$bus.emit("openLogin");

                return _context6.abrupt("return");

              case 7:
                _context6.next = 9;
                return dsteem.followUser(_this6.userName, isFollow);

              case 9:
                result = _context6.sent;

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    mute: function mute(isMute) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var result;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.isMuted = isMute;
                _this7.loginData = extractLoginData();

                if (_this7.loginData) {
                  _context7.next = 7;
                  break;
                }

                _this7.$bus.emit("openLogin");

                return _context7.abrupt("return");

              case 7:
                _context7.next = 9;
                return dsteem.muteUser(_this7.userName, isMute);

              case 9:
                result = _context7.sent;

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var myfollowing, myMuteing;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _this8.userName = _this8.$route.params.username.replace("@", "");

              _this8.loadAccount();

              _context8.next = 4;
              return dsteem.getAccountBlogsByBridge(_this8.loginData ? _this8.loginData[0] : null, "blog", _this8.userName, 20);

            case 4:
              _this8.blogs = _context8.sent;
              _context8.next = 7;
              return dsteem.getAccountBlogsByBridge(_this8.loginData ? _this8.loginData[0] : null, "posts", _this8.userName, 20);

            case 7:
              _this8.posts = _context8.sent;
              _this8.loginData = extractLoginData();

              if (!_this8.loginData) {
                _context8.next = 19;
                break;
              }

              _this8.isSelf = _this8.loginData[0] == _this8.userName;
              _context8.next = 13;
              return dsteem.getFollowing(_this8.loginData[0]);

            case 13:
              myfollowing = _context8.sent;
              _this8.isFollowed = myfollowing.filter(function (item) {
                return item.following == _this8.userName;
              }).length >= 1;
              _context8.next = 17;
              return dsteem.getFollowing(_this8.loginData[0], true);

            case 17:
              myMuteing = _context8.sent;
              _this8.isMuted = myMuteing.filter(function (item) {
                return item.following == _this8.userName;
              }).length >= 1;

            case 19:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  }
};